import { PageState, State } from "../state";

export interface SetNoiseReductionLevelAction {
  image: HTMLImageElement;
  index: number;
  noiseReduction: number;
  type: "SET NOISE REDUCTION LEVEL";
}

const setNoiseReductionLevelOnPage = (
  state: PageState,
  action: SetNoiseReductionLevelAction,
): PageState => {
  if (state.image === action.image && state.noiseReductionLevel === action.noiseReduction) {
    return state;
  }
  return {
    ...state,
    image: action.image,
    noiseReductionLevel: action.noiseReduction,
  };
};

export const setNoiseReductionLevel = (
  state: State,
  action: SetNoiseReductionLevelAction,
): State => {
  const updatedPage = setNoiseReductionLevelOnPage(state.pages[action.index], action);
  if (updatedPage === state.pages[action.index]) {
    return state;
  }
  return {
    ...state,
    pages: [
      ...state.pages.slice(0, action.index),
      updatedPage,
      ...state.pages.slice(action.index + 1),
    ],
  };
};
